export const authConstants = {
  OM_AUTH_USER: 'om-auth-user',
  OM_AUTH_USER_ID: 'om-auth-user-id',
  OM_AUTH_IS_FIRST_LOGIN: 'om-is-first-login',
  OM_AUTH_USER_EXPIRY: 'om-auth-user-expiry',
  OM_AUTH_USER_REFRESH_TOKEN: 'om-auth-user-refresh-token',
};

export const OMREQUESTSOURCE = 'MFL_ONE_WEBSITE';
export const XSRFHeader = '__HOST-XSRF-TOKEN';
